export default __webpack_public_path__ + "static/media/pic2.ea10957a.jpg";